// import React, { useState, useEffect } from "react";
// import {
//   TextField,
//   Grid,
//   Typography,
//   Button,
//   Paper,
//   Box,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
// } from "@mui/material";
// import { AttachFile } from "@mui/icons-material";
// import useDecodedUser from "../../../../../services/hooks/useDecodedUser";
// import FormContainer from "../../../../../components/Forms/FormContainer";
// import { ExecuteApiToPost, GetDataFromApiWithParams } from "../../../../../services/api/ExecuteApiRequests";

// export default function IssueBuildingPermit() {
//   const decodedUser = useDecodedUser();
//   const [id, setId] = useState("");
//   const [permit_no, setPermitNo] = useState("");
//   const [tinNo, setTinNo] = useState("");
//   const [upin, setUPIN] = useState("");
//   const [owner_id, setOwnerId] = useState("");
//   const [requestNumbers, setRequestNumbers] = useState([]);
//   const [issued_on, setIssuedOn] = useState("");
//   const [starting_date, setStartingDate] = useState("");
//   const [finishing_date, setFinishingDate] = useState("");
//   const [status, setStatus] = useState("Finished");
//   const [description, setDescription] = useState("");
//   const [plan_files, setPlanFiles] = useState([]);
//   const [responseMessage, setResponseMessage] = useState("");
//   const [data, setData] = useState(null);

//   useEffect(() => {
//     // Fetch request numbers from the API
//     GetDataFromApiWithParams('buildingPermits')
//       .then((response) => {
//         setRequestNumbers(response);
//       })
//       .catch((error) => console.error("Error fetching request numbers", error));
//   }, []);

//   const handleSubmit = async (e) => {
    
//     e.preventDefault();
//     try {
//       const response = await ExecuteApiToPost("buildingPermits/update", {
//         id,
//         permit_no,
//         upin,
//         owner_id,
//         permit_issued_by: decodedUser && decodedUser.full_name,
//         issued_on,
//         starting_date,
//         finishing_date,
//         status,
//         description,
//         permit_no,
//         plan_files,
//       });
//       if (response) {
//         setResponseMessage("Building Permit Registration successful!");
//       } else {
//         setResponseMessage("Building Permit Registration failed: " + response);
//       }
//     } catch (error) {
//       setResponseMessage("An error occurred: " + error.message);
//       console.log(error);
//     }
//   };

//   const handleKeySubmit = async () => {
//     try {
//       if (!permit_no) {
//         return;
//       }
//       const responseData = await GetDataFromApiWithParams(`buildingPermits/${permit_no}`);
//       setData(responseData);
//     } catch (error) {
//       console.error("Error fetching data", error);
//     }
//   };

//   return (
//     <FormContainer title="Issue Building Permit" onSubmit={handleSubmit}>
//       <Box sx={{ flexGrow: 1, padding: 2 }}>
//         <Grid container spacing={3}>
//           <Grid item xs={12} md={6}>
//             <Paper sx={{ padding: 2 }}>
//               <Grid container spacing={2}>
//                 <Grid item xs={12} md={12}>
//                   <TextField
//                     name="id"
//                     label="Id"
//                     value={id}
//                     onChange={(e) => setId(e.target.value)}
//                     fullWidth={true}
//                   />
//                 </Grid>
//                 <Grid item xs={12} md={6}>
//                   <FormControl fullWidth={true}>
//                     <InputLabel>Request Number</InputLabel>
//                     <Select
//                       value={permit_no}
//                       onChange={(e) => setPermitNo(e.target.value)}
//                     >
//                       {requestNumbers.map((num) => (
//                         <MenuItem key={num.id} value={num.id}>
//                           {num.id}
//                         </MenuItem>
//                       ))}
//                     </Select>
//                   </FormControl>
//                 </Grid>
//                 <Grid item xs={12} md={6}>
//                   <Button
//                     onClick={handleKeySubmit}
//                     variant="contained"
//                     fullWidth={true}
//                   >
//                     {"Fetch Data"}
//                   </Button>
//                 </Grid>
//                 <Grid item xs={12} md={12}>
//                   <TextField
//                     type="text"
//                     id="permit_issued_by"
//                     value={decodedUser.full_name}
//                     placeholder="Issued By"
//                     fullWidth={true}
//                     required
//                     disabled
//                   />
//                 </Grid>
//                 <Grid item xs={12} md={12}>
//                   <TextField
//                     label="Issued on"
//                     type="date"
//                     value={issued_on}
//                     onChange={(e) => setIssuedOn(e.target.value)}
//                     fullWidth={true}
//                     InputLabelProps={{ shrink: true }}
//                   />
//                 </Grid>
//                 <Grid item xs={12} md={6}>
//                   <TextField
//                     label="Starting Date"
//                     type="date"
//                     value={starting_date}
//                     onChange={(e) => setStartingDate(e.target.value)}
//                     fullWidth={true}
//                     InputLabelProps={{ shrink: true }}
//                   />
//                 </Grid>
//                 <Grid item xs={12} md={6}>
//                   <TextField
//                     label="Finishing Date"
//                     type="date"
//                     value={finishing_date}
//                     onChange={(e) => setFinishingDate(e.target.value)}
//                     fullWidth={true}
//                     InputLabelProps={{ shrink: true }}
//                   />
//                 </Grid>
//                 <Grid item xs={12} md={12}>
//                   <TextField
//                     type="text"
//                     id="status"
//                     value={status}
//                     onChange={(e) => setStatus(e.target.value)}
//                     required
//                     fullWidth={true}
//                   />
//                 </Grid>
//                 <Grid item xs={12} md={12}>
//                   <FormControl fullWidth={true}>
//                     <Button
//                       variant="contained"
//                       component="label"
//                       startIcon={<AttachFile />}
//                     >
//                       Attach Requests Form
//                       <input
//                         type="file"
//                         accept=".pdf, .docx, .doc, .jpeg, .jpg, .png"
//                         onChange={(e) => setPlanFiles(e.target.files[0])}
//                         style={{ display: "none" }}
//                       />
//                     </Button>
//                   </FormControl>
//                 </Grid>
//               </Grid>
//             </Paper>
//           </Grid>
//           <Grid item xs={12} md={6}>
//             <Paper sx={{ padding: 2 }}>
//               {data ? (
//                 <>
//                   <Typography variant="h5"> <center>Fetched Information</center></Typography>
//                   <br></br>
//                    <Typography variant="body1">Owners: {data[0].owners}</Typography>
//                    <Typography variant="body1">Permit No: {data[0].permit_no || "NA"}</Typography>
//                   <Typography variant="body1">TIN No: {data[0].tin_no || "NA"}</Typography>
//                   <Typography variant="body1">Parcel No: {data[0].upin || "N/A"}</Typography>
                  
//                 </>
//               ) : (
//                 <Typography variant="body1">No data fetched yet.</Typography>
//               )}
//             </Paper>
//           </Grid>
//         </Grid>
//       </Box>
//       <Grid item xs={12} md={12}>
//         <FormControl fullWidth={true}>
//           <TextField
//             rows={3}
//             name="description"
//             id="description"
//             label="Description"
//             value={description}
//             onChange={(e) => setDescription(e.target.value)}
//           />
//         </FormControl>
//       </Grid>
//       {responseMessage && <p>{responseMessage}</p>}
//     </FormContainer>
//   );
// }

import React, { useState, useEffect } from "react";
import {
  TextField,
  Grid,
  Typography,
  Button,
  Paper,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import { AttachFile } from "@mui/icons-material";
import useDecodedUser from "../../../../../services/hooks/useDecodedUser";
import FormContainer from "../../../../../components/Forms/FormContainer";
import { ExecuteApiToPost, GetDataFromApiWithParams } from "../../../../../services/api/ExecuteApiRequests";

export default function IssueBuildingPermit() {
  const decodedUser = useDecodedUser();
  const [id, setId] = useState("");
  const [permit_no, setPermitNo] = useState("");
  const [tinNo, setTinNo] = useState("");
  const [upin, setUPIN] = useState("");
  const [owner_id, setOwnerId] = useState("");
  const [requestNumbers, setRequestNumbers] = useState([]); // Initialize as empty array
  const [issued_on, setIssuedOn] = useState("");
  const [starting_date, setStartingDate] = useState("");
  const [finishing_date, setFinishingDate] = useState("");
  const [status, setStatus] = useState("Finished");
  const [description, setDescription] = useState("");
  const [plan_files, setPlanFiles] = useState([]);
  const [responseMessage, setResponseMessage] = useState("");
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false); // Add loading state

  useEffect(() => {
    // Fetch request numbers from the API
    setLoading(true);
    GetDataFromApiWithParams('occupancyPermits')
      .then((response) => {
        setRequestNumbers(response || []); // Ensure it's always an array
      })
      .catch((error) => {
        console.error("Error fetching request numbers", error);
        setRequestNumbers([]); // Set to empty array on error
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await ExecuteApiToPost("occupancyPermits/occupancyupdate", {
        id,
        permit_no,
        upin,
        owner_id,
        permit_issued_by: decodedUser && decodedUser.full_name,
        issued_on,
        starting_date,
        finishing_date,
        status,
        description,
        permit_no,
        plan_files,
      });
      if (response) {
        setResponseMessage("Occupancy Permit Issued successful!");
      } else {
        setResponseMessage("Occupancy Permit Issued failed: " + response);
      }
    } catch (error) {
      setResponseMessage("An error occurred: " + error.message);
      console.log(error);
    }
  };

  const handleKeySubmit = async () => {
    
    try {
      if (!permit_no) {
        return;
      }
      const responseData = await GetDataFromApiWithParams(`occupancyPermits/${permit_no}`);
      
      setData(responseData);
      console.log("abe:",data)
    } catch (error) {
      console.error("Error fetching data", error);
    }
  };

  return (
    <FormContainer title="Issue Occupancy Permit" onSubmit={handleSubmit}>
      <Box sx={{ flexGrow: 1, padding: 2 }}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <Paper sx={{ padding: 2 }}>
              <Grid container spacing={2}>
                {/* <Grid item xs={12} md={12}>
                  <TextField
                    name="id"
                    label="Id"
                    value={id}
                    onChange={(e) => setId(e.target.value)}
                    fullWidth={true}
                  />
                </Grid> */}
                <Grid item xs={12} md={6}>
                  <FormControl fullWidth={true}>
                    <InputLabel>Request Number</InputLabel>
                    <Select
                      value={permit_no}
                      onChange={(e) => setPermitNo(e.target.value)}
                      disabled={loading} // Disable while loading
                    >
                      {/* Add safe mapping with optional chaining */}
                      {requestNumbers?.map((num) => (
                        <MenuItem key={num.id} value={num.id}>
                          {num.id}
                        </MenuItem>
                      )) || []}
                    </Select>
                    {loading && <Typography variant="body2">Loading request numbers...</Typography>}
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Button
                    onClick={handleKeySubmit}
                    variant="contained"
                    fullWidth={true}
                    disabled={!permit_no || loading}
                  >
                    {"Fetch Data"}
                  </Button>
                </Grid>
                <Grid item xs={12} md={12}>
                  <TextField
                    type="text"
                    id="permit_issued_by"
                    value={decodedUser?.full_name || ""} // Safe access
                    placeholder="Issued By"
                    fullWidth={true}
                    required
                    disabled
                  />
                </Grid>
                <Grid item xs={12} md={12}>
                  <TextField
                    label="Issued on"
                    type="date"
                    value={issued_on}
                    onChange={(e) => setIssuedOn(e.target.value)}
                    fullWidth={true}
                    InputLabelProps={{ shrink: true }}
                  />
                </Grid>
                {/* <Grid item xs={12} md={6}>
                  <TextField
                    label="Starting Date"
                    type="date"
                    value={starting_date}
                    onChange={(e) => setStartingDate(e.target.value)}
                    fullWidth={true}
                    InputLabelProps={{ shrink: true }}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    label="Finishing Date"
                    type="date"
                    value={finishing_date}
                    onChange={(e) => setFinishingDate(e.target.value)}
                    fullWidth={true}
                    InputLabelProps={{ shrink: true }}
                  />
                </Grid> */}
                <Grid item xs={12} md={12}>
                  <TextField
                    type="text"
                    id="status"
                    value={status}
                    onChange={(e) => setStatus(e.target.value)}
                    required
                    fullWidth={true}
                  />
                </Grid>
                <Grid item xs={12} md={12}>
                  <FormControl fullWidth={true}>
                    <Button
                      variant="contained"
                      component="label"
                      startIcon={<AttachFile />}
                    >
                      Attach Requests Form
                      <input
                        type="file"
                        accept=".pdf, .docx, .doc, .jpeg, .jpg, .png"
                        onChange={(e) => setPlanFiles(e.target.files[0])}
                        style={{ display: "none" }}
                      />
                    </Button>
                  </FormControl>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
          <Grid item xs={12} md={6}>
            <Paper sx={{ padding: 2 }}>
              {data ? (
                <>
                  <Typography variant="h5"> <center>Fetched Information</center></Typography>
                  <br></br>
                  {/* Add safe access for data array */}
                  <Typography variant="body1">Owners: {data[0]?.owners || "N/A"}</Typography>
                  <Typography variant="body1">Building Permit No: {data[0]?.build_permit_id || "NA"}</Typography>
                  <Typography variant="body1">TIN No: {data[0]?.tin_no || "NA"}</Typography>
                  <Typography variant="body1">Parcel No: {data[0]?.upin || "N/A"}</Typography>
                  <Typography variant="body1">Park: {data[0]?.name || "N/A"}</Typography>
                </>
              ) : (
                <Typography variant="body1">No data fetched yet.</Typography>
              )}
            </Paper>
          </Grid>
        </Grid>
      </Box>
      <Grid item xs={12} md={12}>
        <FormControl fullWidth={true}>
          <TextField
            rows={3}
            name="description"
            id="description"
            label="Description"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
        </FormControl>
      </Grid>
      {responseMessage && <p>{responseMessage}</p>}
    </FormContainer>
  );
}